import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useEffect } from 'react';
import Calendar from '../Calendar/Calendar.js';
import '../Calendar/index.js';
import { CalendarMenu } from './style.js';

var DatePickerMenu = function DatePickerMenu(_a) {
  var menuOpened = _a.menuOpened,
      value = _a.value,
      inputRef = _a.inputRef,
      changeDate = _a.changeDate,
      _setMenuOpen = _a.setMenuOpen,
      dateFormat = _a.dateFormat,
      placement = _a.placement,
      rest = __rest(_a, ["menuOpened", "value", "inputRef", "changeDate", "setMenuOpen", "dateFormat", "placement"]);

  var menuRef = useRef(null);

  var handleClickOutside = function handleClickOutside(e) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;

    var test = e.target.parentNode;

    if ( // Must be some better way to test if the button is being clicked or not
    menuRef.current !== e.target && menuRef.current !== ((_d = (_c = (_b = (_a = test === null || test === void 0 ? void 0 : test.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode) === null || _c === void 0 ? void 0 : _c.parentNode) === null || _d === void 0 ? void 0 : _d.parentNode) && menuRef.current !== ((_j = (_h = (_g = (_f = (_e = test === null || test === void 0 ? void 0 : test.parentNode) === null || _e === void 0 ? void 0 : _e.parentNode) === null || _f === void 0 ? void 0 : _f.parentNode) === null || _g === void 0 ? void 0 : _g.parentNode) === null || _h === void 0 ? void 0 : _h.parentNode) === null || _j === void 0 ? void 0 : _j.parentNode) && menuRef.current !== ((_q = (_p = (_o = (_m = (_l = (_k = test === null || test === void 0 ? void 0 : test.parentNode) === null || _k === void 0 ? void 0 : _k.parentNode) === null || _l === void 0 ? void 0 : _l.parentNode) === null || _m === void 0 ? void 0 : _m.parentNode) === null || _o === void 0 ? void 0 : _o.parentNode) === null || _p === void 0 ? void 0 : _p.parentNode) === null || _q === void 0 ? void 0 : _q.parentNode)) {
      if (menuRef.current) {
        _setMenuOpen(false, true);
      }
    }
  };

  useEffect(function () {
    document.addEventListener('mousedown', function (e) {
      return handleClickOutside(e);
    });
    return function () {
      document.removeEventListener('mousedown', function (e) {
        return handleClickOutside(e);
      });
    };
  });
  useEffect(function () {
    return function () {
      menuRef.current = null;
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, menuOpened && /*#__PURE__*/React.createElement(CalendarMenu, __assign({
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 27) {
        e.preventDefault();

        if (menuRef.current) {
          _setMenuOpen(false, true);

          inputRef.current.focus();
        }
      }
    },
    role: "dialog",
    "aria-expanded": "true",
    ref: menuRef,
    fitWidthToContent: true,
    referenceElement: inputRef.current,
    placement: placement
  }, rest), /*#__PURE__*/React.createElement(Calendar, {
    dateFormat: dateFormat,
    menuRef: menuRef,
    inputRef: inputRef,
    autoFocusDay: true,
    setMenuOpen: function setMenuOpen(value) {
      return _setMenuOpen(value, true);
    },
    onDateChange: function onDateChange(date) {
      return changeDate(date);
    },
    selectedDate: value
  })));
};

export default DatePickerMenu;